import * as React from 'react';
import { IStaticPageWrapperProps, StaticPageWrapper, centeredMessageStyle } from 'components/static-pages/StaticPageWrapper';


export const HeadspacePage = (props:IStaticPageWrapperProps) =>
	<StaticPageWrapper 
		backgroundImage="/res_sys/headspace_splash.png" 
		backgroundSize="cover" 
		{...props}
	>
		<div style={centeredMessageStyle}>
			<div style={{textAlign:'center',fontFamily:'Georgia',fontWeight:900,fontSize:'32px',color:'#263692', paddingTop:'20px', paddingBottom:'25px',lineHeight: '32px'}}>
				<img style={{width:'260px', marginTop:'25px', height:'auto'}} src="/res_sys/headspace_logo.png"/>
			</div>
			<div style={{fontSize:'18px',fontFamily:'Georgia', fontWeight:300, fontStyle:'normal',color:'#263692', textAlign:'center',paddingBottom:'30px'}}>We recommend downloading Headspace.</div>
			<div style={{textAlign:'center', marginTop:'0px', marginBottom:'25px'}}>
				<a target="_blank" aria-label={`GET THE APP, opens new tab`} href={'https://www.headspace.com/'} className="go_button" style={{backgroundColor:'#293ccc', borderRadius:'3px',boxShadow: '2px 2px 4px 0px rgba(0,0,0,0.5)'}}>GET THE APP</a>
			</div>
			<div style={{fontSize:'18px',fontFamily:'Georgia',fontWeight:600, fontStyle:'italic',color:'#4A4A4A', textAlign:'center',paddingBottom:'30px'}}>
			Brilliant things happen in calm minds<br/><br/>
			</div>
		</div>
	</StaticPageWrapper>
;
